var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standart-card',{attrs:{"title":"Mémoire utilisée","height":"375px"}},[_c('div',[_c('line-chart',{attrs:{"styles":{ height: '300px' },"chart-data":_vm.datacollection,"options":{
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: '#ffffff'
          }
        }
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }